import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { deleteClassificacaoById, fetchAllClassificacoesByReino } from '../../../store/Classificacao/classificacaoSlice';
import { RootState } from '../../../store/store';
import DynamicTable from '@atlaskit/dynamic-table';
import Modal from '@atlaskit/modal-dialog';
import Button from '@atlaskit/button';
import { H3 } from '../Tipografia/Texto';
import { Classificacao } from 'model/classificacao/Classificacao';

interface ClassificacaoTableProps {
  onEdit: (classificacao: Classificacao) => void;
}

const ClassificacaoTable: React.FC<ClassificacaoTableProps> = ({ onEdit }) => {
  const dispatch = useDispatch();
  const classificacoes = useSelector((state: RootState) => state.classificacao.data);
  const status = useSelector((state: RootState) => state.classificacao.status);

  const [deleteConfirmationOpen, setDeleteConfirmationOpen] = useState(false);
  const [deleteClassificacaoId, setDeleteClassificacaoId] = useState<number | null>(null);


  useEffect(() => {
    if (status === 'idle') {
      dispatch(fetchAllClassificacoesByReino());
    }
  }, [status, dispatch]);

  const handleDeleteConfirmation = (id: number) => {
    setDeleteClassificacaoId(id);
    setDeleteConfirmationOpen(true);
  };

  const handleDelete = () => {
    if (deleteClassificacaoId) {
      (async () => {
        await dispatch(deleteClassificacaoById(deleteClassificacaoId));
        dispatch(fetchAllClassificacoesByReino());
        setDeleteConfirmationOpen(false);
      })();
    }
  };

  const handleCloseDeleteConfirmation = () => {
    setDeleteConfirmationOpen(false);
  };

  const head = {
    cells: [
      { key: 'id', content: 'ID', isSortable: true },
      { key: 'nome', content: 'Nome', isSortable: true },
      { key: 'paiId', content: 'ID Classificação Pai', isSortable: true },
      { key: 'reinoId', content: 'ID Reino', isSortable: true },
      { key: 'unidadeId', content: 'ID Unidade', isSortable: true },
      { key: 'actions', content: 'Ações' },
    ],
  };

  const rows = classificacoes.map((classificacao: { id: number; nome: any; paiId: any; reinoId: any; unidadeId: any; }) => ({
    key: `row-${classificacao.id}`,
    cells: [
      { key: classificacao.id, content: classificacao.id },
      { key: classificacao.nome, content: classificacao.nome },
      { key: classificacao.paiId, content: classificacao.paiId || '-' },
      { key: classificacao.reinoId, content: classificacao.reinoId },
      { key: classificacao.unidadeId, content: classificacao.unidadeId },
      {
        key: 'actions',
        content: (
          <>
            <Button appearance="subtle" onClick={() => onEdit(classificacao)}>
              Editar
            </Button>
            <Button appearance="subtle" onClick={() => handleDeleteConfirmation(classificacao.id)}>
              Deletar
            </Button>
          </>
        ),
      },
    ],
  }));

  return (
    <div>
      <H3>Classificações</H3>
      <DynamicTable
        head={head}
        rows={rows}
        rowsPerPage={20}
        defaultPage={1}
        loadingSpinnerSize="large"
        isLoading={status === 'loading'}
        isFixedSize
        defaultSortKey="id"
        defaultSortOrder="ASC"
        onSort={() => { }}
        onSetPage={() => { }}
      />

      {deleteConfirmationOpen && (
        <Modal
          heading="Confirmação de exclusão"
          appearance="danger"
          onClose={handleCloseDeleteConfirmation}
          actions={[
            { text: 'Excluir', onClick: handleDelete },
            { text: 'Cancelar', onClick: handleCloseDeleteConfirmation },
          ]}
        >
          <p>Tem certeza de que deseja excluir esta classificação?</p>
        </Modal>
      )}
    </div>

  );
};

export default ClassificacaoTable;
